import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeHigh, faVolumeXmark } from '@/fontawesome';
import { showSoundBlockedToast } from '@/hooks/useNotificationSound';

interface SoundMuteButtonProps {
  isMuted: boolean;
  onToggle: () => void;
  play: (type: 'connected', options?: { force?: boolean }) => Promise<boolean>;
}

export default function SoundMuteButton({ isMuted, onToggle, play }: SoundMuteButtonProps) {
  const handleClick = async () => {
    const wasMuted = isMuted;
    onToggle();
    if (wasMuted) {
      // Going from muted -> unmuted: play the join sound to confirm
      // playback permission and warm up the audio element.
      const ok = await play('connected', { force: true });
      if (!ok) {
        showSoundBlockedToast();
      }
    }
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center justify-center w-8 h-8 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
      title={isMuted ? 'Ton aktivieren' : 'Ton deaktivieren'}
    >
      <FontAwesomeIcon icon={isMuted ? faVolumeXmark : faVolumeHigh} className="w-4 h-4" />
    </button>
  );
}
